import React, { Component, lazy, Suspense } from 'react'
import { Header } from 'components/Header'
import { Menu } from 'components/Menu'
import { NavigationBar } from 'components/NavigationBar'
import { css } from 'aphrodite'
import styles from './styles'
import { state, signal } from 'cerebral/tags'
import { connect } from '@cerebral/react'
import { CurrentView } from './CurrentView'
import { Footer } from 'components/Footer'
import { Terms } from 'components/StartPage/Terms'
import { Snackbar } from 'components/Common/Snackbar'
import { Dialog } from 'components/Common/Dialog'
import { Node } from 'components/Node'
import { Loader } from 'components/App/Loader'
import { t } from '@billes/translator-client'

const Detail = lazy(() => import('../Media/Detail/detail'))

const App = connect(
  {
    loading: state`app.loading`,
    handleError: signal`app.handleError`,
    onMouseUp: signal`media.onMouseUp`,
    isUploading: state`media.isUploading`
  },
  class App extends Component {
    state = {}

    constructor(props) {
      super(props)
      this.onUnload = this.onUnload.bind(this)
    }

    onUnload(event) {
      const { isUploading } = this.props
      if (isUploading) {
        event.returnValue = t('bms.app.uploadWarning')
      }
    }

    componentDidMount() {
      window.addEventListener('beforeunload', this.onUnload)
    }

    componentWillUnmount() {
      window.removeEventListener('beforeunload', this.onUnload)
    }

    static getDerivedStateFromError(error) {
      return { hasError: true }
    }

    componentDidCatch(error, info) {
      this.props.handleError({
        error,
        customError: { message: error.toString(), stack: error.stack }
      })
    }

    render() {
      const { loading } = this.props
      if (this.state.hasError) return <Dialog />

      if (loading) {
        return (
          <div
            style={{
              height: '100vh',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
            <Dialog />
            <Loader />
          </div>
        )
      }
      return (
        <div
          className={css(styles.app)}
          onMouseUp={e => {
            e.preventDefault()
            e.stopPropagation()
            const { onMouseUp } = this.props
            onMouseUp()
          }}>
          <Suspense fallback={null}>
            <Detail />
          </Suspense>
          <header className={css(styles.header)}>
            <Header />
            <NavigationBar />
          </header>
          <div className={css(styles.content)}>
            <CurrentView />
            <Menu />
            <Node />
          </div>
          <footer className={css(styles.footer)}>
            <Footer />
          </footer>
          <Terms />
          <Snackbar />
          <Dialog />
        </div>
      )
    }
  }
)

export default App



// WEBPACK FOOTER //
// ./src/components/App/index.js